import React, { useState, useEffect, useRef } from "react";
import TextField from "./TextField";

const CustomAutoCompleteWithImg = ({
  value,
  options,
  toSkip,
  dropdownWidth,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(value);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    setSearchTerm(""); // Reset search on selection
    if (onChange) {
      onChange(option);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredOptions = options.filter(
    (item) =>
      item.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
      item.label !== toSkip
  );

  return (
    <div
      className="select-tag custom-select myprofile-general-value"
      ref={dropdownRef}
      style={{display:"flex" , alignItems:"center"}}
    >
      <div
        className="select-box"
        style={{ width: "100%" , display:"flex" , alignItems:"baseline" , gap:"7px"}}
        onClick={toggleDropdown}
      >
        <img
        
          loading="lazy"
          width="20"
          srcSet={`https://flagcdn.com/w40/${selected.label
            .split(":")[0]
            .toLowerCase()}.png 2x`}
          src={`https://flagcdn.com/w20/${selected.label
            .split(":")[0]
            .toLowerCase()}.png`}
          alt=""
        />{" "}
        {selected.label.split(":")[1]}
        <span className="arrow">▼</span>
      </div>
      {isOpen && (
        <>
          <div className="dropdown" style={{ width: dropdownWidth }}>
            <div className="search-field">
              <TextField
                // fullWidth
                // onChange={onChangeInput}
                // name="address"
                // value={editableGeneralDetails.address}
                placeholder={"Search ... "}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                focus={true}
                // autoFocus
              />
            </div>
            <div className="dropdown-options">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <div
                    key={index}
                    className={`dropdown-item ${
                      option.label === selected.label ? "active" : ""
                    }`}
                    onClick={() => handleSelect(option)}
                  >
                    <img
                      style={{ marginRight: "8px" }}
                      loading="lazy"
                      width="20"
                      srcSet={`https://flagcdn.com/w40/${option.label
                        .split(":")[0]
                        .toLowerCase()}.png 2x`}
                      src={`https://flagcdn.com/w20/${option.label
                        .split(":")[0]
                        .toLowerCase()}.png`}
                      alt=""
                    />{" "}
                    {option.label.split(":")[1]}
                  </div>
                ))
              ) : (
                <div className="dropdown-item no-options">No results found</div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomAutoCompleteWithImg;
